import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'

import {
  Badge,
  BtnIcon,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  Loading,
  NumeroDecimal,
  PageHeader,
  Periodo,
  ThreeDots,
  Btn,
  InputText,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import * as colors from '../../../../assets/js/colors'
import { FaBoxes } from 'react-icons/fa'
import { selectedFeetChanged } from '../../../../store/actions/retorno-veiculo.actions'
import { formatDateToLocale } from '../../../../services/util/date.service'
import { useHistoricoVeiculoRetornadoContext } from '../../../../contexts/EntregaContext'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'

export const MENU_ITEMS = ['1. Geoposicionamento', '2. Bateria', '3. Chat']

function VeiculosRetornados({ dispatch, selectedTp, history }) {
  const context = useHistoricoVeiculoRetornadoContext()

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [isSearching, setIsSearching] = useState(false)
  const [notaFiscal, setNotaFiscal] = useState(
    context.historicoVeiculoRetornadoContext.notaFiscal || '',
  )
  const [state, setState] = useState({
    periodo: context.historicoVeiculoRetornadoContext.selectedPeriodo,
    selectedVehicle: context.historicoVeiculoRetornadoContext.selectedVeiculo,
    selectedDriver: context.historicoVeiculoRetornadoContext.selectedMotorista,
    vehicles: [],
    drivers: [],
    frotas: [],
    frotasFilterd: [],
  })
  const [empresas] = useState(getEmpresas())
  const [selectedEmpresa, setSelectedEmpresa] = useState(null)
  const [selecionarTodos, setSelecionarTodos] = useState(false)

  useEffect(() => {
    if (!selectedTp) {
      dispatch(showMessageBox(null, `Selecione um operador logístico`))
      setIsLoading(false)
      return
    }
    _fetchVeiculosRetorno()
  }, [selectedTp])

  useEffect(() => {
    if (selectedTp) _fetchVeiculosRetorno()
  }, [state.periodo])

  useEffect(() => {
    if (context.historicoVeiculoRetornadoContext.notaFiscal) {
      setNotaFiscal(context.historicoVeiculoRetornadoContext.notaFiscal)
    }
  }, [])

  // Event

  const onMenuItemClicked = (item, frota) => {
    switch (item) {
      case '1. Geoposicionamento':
        history.push('/main/entregas/geoposicionamento', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
        })
        break
      case '2. Bateria':
        history.push('/main/entregas/bateria-celular', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
        })
        break
      case '3. Chat':
        history.push('/main/entregas/chat', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
          tp_id: selectedTp,
          driver_id: frota.driver_id,
          disabled: true,
          expected_date: formatDateToLocale(frota.expected_date, 'dd/MM/yyyy').toISO(),
        })
        break
      default:
        break
    }
  }

  const onDataTableItemClicked = frota => {
    const index = state.frotasFilterd.findIndex(f => f.fleet_id === frota.fleet_id)
    if (index !== -1) {
      state.frotasFilterd[index].selected = !state.frotasFilterd[index].selected
      setState({ ...state, frotasFilterd: [...state.frotasFilterd] })
    }
  }

  const onSelecionarTodosClicked = value => {
    setSelecionarTodos(value)
    state.frotasFilterd.forEach(f => {
      f.selected = value
    })
    state.frotas.forEach(f => {
      f.selected = value
    })
    setState({ ...state, frotasFilterd: [...state.frotasFilterd] })
  }

  const onDeliveriesIconClicked = frota => {
    if (frota.acess_to_all_companies === false) {
      dispatch(
        showMessageBox(null, 'Usuário não tem acesso a todas as empresas associadas ao veículo'),
      )
      return
    }
    dispatch(selectedFeetChanged(frota))
    history.push('/main/entregas/veiculos-retornados-apuracao', {
      fleet_id: frota.fleet_id,
      vehicle_badge: frota.vehicle_badge,
      driver_id: frota.driver_id,
      expected_date: formatDateToLocale(frota.expected_date, 'dd/MM/yyyy').toISO(),
    })
  }

  // Helper
  const _fetchVeiculosRetorno = async () => {
    try {
      setIsLoading(true)
      const fetchedFrotas = await RetornoHttp.getReturnedVehicles(
        selectedTp,
        state.periodo.dataInicial,
        state.periodo.dataFinal,
      )
      const vehicles = new Set()
      const drivers = new Set()
      fetchedFrotas.forEach(frota => {
        vehicles.add(frota.vehicle_badge)
        drivers.add(frota.vehicle_driver)
      })
      const vehiclesArray = Array.from(vehicles)
      const driversArray = Array.from(drivers)

      let frotasFilterd = fetchedFrotas
      if (state.selectedVehicle)
        frotasFilterd = frotasFilterd.filter(
          frota => frota.vehicle_badge === state.selectedVehicle.vehicle_badge,
        )
      if (state.selectedDriver)
        frotasFilterd = frotasFilterd.filter(
          frota => frota.vehicle_driver === state.selectedDriver.vehicle_driver,
        )
      setState({
        ...state,
        vehicles: vehiclesArray.map(vehicle_badge => ({
          vehicle_badge: vehicle_badge,
          id: vehicle_badge,
        })),
        drivers: driversArray.map(vehicle_driver => ({
          vehicle_driver: vehicle_driver,
          id: vehicle_driver,
        })),
        frotasFilterd,
        frotas: fetchedFrotas,
      })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  const buscarPorNotaFiscal = async () => {
    // 1) validações
    if (!selectedTp) {
      dispatch(showMessageBox(null, errorHandler(new Error('Selecione um TP antes de buscar'))))
      return
    }
    if (!notaFiscal.trim()) {
      dispatch(showMessageBox(null, errorHandler(new Error('Digite a Nota Fiscal para buscar'))))
      return
    }
    if (!selectedEmpresa) {
      dispatch(showMessageBox(null, errorHandler(new Error('Selecione uma empresa para buscar'))))
      return
    }
    if (!state.periodo || !state.periodo.dataInicial || !state.periodo.dataFinal) {
      dispatch(showMessageBox(null, errorHandler(new Error('Selecione o período para buscar'))))
      return
    }

    context.setHistoricoVeiculoRetornadoContext({
      ...context.historicoVeiculoRetornadoContext,
      notaFiscal: notaFiscal.trim(),
    })

    setIsSearching(true)
    try {
      const fetchedFrotas = await RetornoHttp.getReturnedVehiclesByNF(
        selectedTp,
        state.periodo.dataInicial,
        state.periodo.dataFinal,
        notaFiscal.trim(),
        selectedEmpresa.id,
      )

      const vehicles = new Set()
      const drivers = new Set()
      fetchedFrotas.forEach(frota => {
        vehicles.add(frota.vehicle_badge)
        drivers.add(frota.vehicle_driver)
      })
      const vehiclesArray = Array.from(vehicles)
      const driversArray = Array.from(drivers)

      let frotasFilterd = fetchedFrotas
      if (state.selectedVehicle)
        frotasFilterd = frotasFilterd.filter(
          frota => frota.vehicle_badge === state.selectedVehicle.vehicle_badge,
        )
      if (state.selectedDriver)
        frotasFilterd = frotasFilterd.filter(
          frota => frota.vehicle_driver === state.selectedDriver.vehicle_driver,
        )
      setState({
        ...state,
        vehicles: vehiclesArray.map(vehicle_badge => ({
          vehicle_badge: vehicle_badge,
          id: vehicle_badge,
        })),
        drivers: driversArray.map(vehicle_driver => ({
          vehicle_driver: vehicle_driver,
          id: vehicle_driver,
        })),
        frotasFilterd,
        frotas: fetchedFrotas,
      })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsSearching(false)
    }
  }

  const onSelectedVeiculoChange = value => {
    let frotasFilterd = state.frotas
    if (value)
      frotasFilterd = state.frotas.filter(frota => frota.vehicle_badge === value.vehicle_badge)
    if (state.selectedDriver)
      frotasFilterd = frotasFilterd.filter(
        frota => frota.vehicle_driver === state.selectedDriver.vehicle_driver,
      )
    setState({ ...state, selectedVehicle: value, frotasFilterd })
    context.setHistoricoVeiculoRetornadoContext({
      ...context.historicoVeiculoRetornadoContext,
      selectedVeiculo: value,
    })
  }

  const onSelectedMotoristaChange = value => {
    let frotasFilterd = state.frotas
    if (value)
      frotasFilterd = state.frotas.filter(frota => frota.vehicle_driver === value.vehicle_driver)
    if (state.selectedVehicle)
      frotasFilterd = frotasFilterd.filter(
        frota => frota.vehicle_badge === state.selectedVehicle.vehicle_badge,
      )
    setState({ ...state, selectedDriver: value, frotasFilterd })
    context.setHistoricoVeiculoRetornadoContext({
      ...context.historicoVeiculoRetornadoContext,
      selectedMotorista: value,
    })
  }
  const onPeriodoChange = (pInicial, pFinal) => {
    setState({
      ...state,
      periodo: {
        dataInicial: pInicial,
        dataFinal: pFinal,
      },
    })
    context.setHistoricoVeiculoRetornadoContext({
      ...context.historicoVeiculoRetornadoContext,
      selectedPeriodo: {
        dataInicial: pInicial,
        dataFinal: pFinal,
      },
    })
  }

  const onBtnExportarExcelClick = async () => {
    const colunas = [
      [
        'placa',
        'nome_motorista',
        'cliente',
        'cidade',
        'cnpj',
        'nota_fiscal',
        'data_emissão_nfe',
        'qtde_caixas',
        'status',
        'data_status',
        'data_operacao',
        'chave_nf',
        'empresa',
        'fleet_id',
        'peso_total',
      ],
    ]

    const selectedFrotas = state.frotasFilterd.filter(f => f.selected)
    const selectedFleetIds = selectedFrotas.map(f => f.fleet_id)

    if (selectedFleetIds.length === 0) {
      dispatch(showMessageBox(null, 'Nenhuma rota selecionada'))
      return
    }

    const invalidFrotas = selectedFrotas.filter(f => f.acess_to_all_companies === false)
    if (invalidFrotas.length > 0) {
      const labels = invalidFrotas.map(f => f.fleet_id).join(' , ')
      dispatch(
        showMessageBox(
          null,
          `Não é possível gerar o arquivo pois o usuário não tem acesso à todas as empresas associadas a(s) rota(s): ${labels}`,
        ),
      )
      return
    }

    try {
      const exportFrotas = await RetornoHttp.getExportVeiculosRetornados(
        selectedTp,
        selectedFleetIds,
      )
      exportFrotas.forEach(e => {
        colunas.push([
          e.vehicle_badge,
          e.vehicle_driver,
          e.cliente,
          e.cidade,
          e.cnpj,
          e.nota_fiscal,
          e.issuance_date,
          e.qte_volumes,
          e.status,
          e.data_status,
          e.data_operacao,
          e.chave_nf,
          e.company_name,
          e.fleet_id,
          e.weight,
        ])
      })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
      return
    }

    gerarArquivoExcel('frotas', colunas, 'veiculos_retornados.xlsx')
  }
  // Render
  return (
    <React.Fragment>
      <PageHeader>3.21 - Histórico de Veículo Retornados</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid p-ai-end">
            <div className="p-col-2">
              <CustomDropdown
                filter={true}
                value={state.selectedVehicle}
                label="Veículo"
                optionLabel="vehicle_badge"
                options={state.vehicles}
                onChange={value => onSelectedVeiculoChange(value, selectedTp)}
              />
            </div>
            <div className="p-col-2">
              <CustomDropdown
                filter={true}
                value={state.selectedDriver}
                label="Motorista"
                optionLabel="vehicle_driver"
                options={state.drivers}
                onChange={value => onSelectedMotoristaChange(value)}
              />
            </div>
            <div className="p-col-3">
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) => onPeriodoChange(pInicial, pFinal)}
              />
              <p>* Data Prevista de Entrega</p>
            </div>
            <div className="p-col-2">
              <Btn
                disabled={!selectedTp}
                onClick={onBtnExportarExcelClick}
                style={{ display: 'inline-block', marginLeft: 16, marginTop: 28 }}
              >
                Exportar Excel
              </Btn>
            </div>
          </div>
          {isLoading ? (
            <div>
              <Loading size="md" />
            </div>
          ) : (
            <React.Fragment>
              <div style={{ marginTop: 20, marginBottom: 10 }}>
                <Fieldset legend="Filtro" toggleable collapsed={true}>
                  <div className="p-grid p-align-center">
                    <div className="p-col-4">
                      <CustomDropdown
                        label="Empresas"
                        optionLabel="name"
                        options={empresas}
                        value={selectedEmpresa}
                        onChange={setSelectedEmpresa}
                        filter={true}
                        placeholder="Selecione uma empresa"
                      />
                    </div>
                    <div className="p-col-4">
                      <InputText
                        label="Nota Fiscal"
                        value={notaFiscal}
                        onChange={value => setNotaFiscal(value)}
                      />
                    </div>
                    <div className="p-col-4" style={{ marginTop: 32 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                        <Btn isLoading={isSearching} onClick={buscarPorNotaFiscal}>
                          Buscar
                        </Btn>
                      </div>
                    </div>
                  </div>
                </Fieldset>
              </div>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <CustomCheckbox checked={selecionarTodos} onChange={onSelecionarTodosClicked}>
                  Selecionar Todos
                </CustomCheckbox>
              </div>
              <DataTableComponent
                frotas={state.frotasFilterd}
                onMenuItemClicked={onMenuItemClicked}
                onIconClicked={onDeliveriesIconClicked}
                onItemClicked={onDataTableItemClicked}
              />
            </React.Fragment>
          )}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

function DataTableComponent({ frotas, onMenuItemClicked, onIconClicked, onItemClicked }) {
  const [globalFilter, setGlobalFilter] = useState('')

  // Events

  // Render
  return (
    <DataTable
      value={frotas}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      emptyMessage="Não existe veículo Retornados para o período selecionado"
      paginator={true}
      rows={10}
    >
      <Column
        header="#"
        style={tableCellCentered(60)}
        body={frota => (
          <CustomCheckbox checked={!!frota.selected} onChange={() => onItemClicked(frota)} />
        )}
      />
      <Column field={'fleet_id'} header="Rota" style={tableCellCentered(80)} />
      <Column field={'expected_date'} header="Data Prevista" style={tableCellCentered(130)} />
      <Column field={'sent_time'} header="Data Envio" style={tableCellCentered()} />
      <Column field={'returned_time'} header="Data Retorno" style={tableCellCentered()} />
      <Column className="text-center" field="vehicle_badge" header="Placa" />
      <Column className="text-center" field="vehicle_driver" header="Motorista" />
      <Column style={tableCellCentered(130)} field="qte_deliveries" header="Qte. Identif." />
      <Column
        style={tableCellCentered(130)}
        header="Possui Falta"
        body={frota =>
          frota.qte_faltas ? (
            <Badge color={colors.vinho}>sim</Badge>
          ) : (
            <Badge color={colors.verde}>não</Badge>
          )
        }
      />
      <Column style={tableCellCentered()} field="qte_sku" header="Qte. Caixas" />
      <Column
        style={tableCellCentered()}
        field="weight"
        header="Peso Total"
        body={item => <NumeroDecimal>{item.weight}</NumeroDecimal>}
      />
      <Column
        header=""
        style={tableCellCentered(60)}
        body={frota => (
          <BtnIcon onClick={() => onIconClicked(frota)}>
            <FaBoxes color="#3ac2bb" size={18} />
          </BtnIcon>
        )}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={frota => (
          <ThreeDots items={MENU_ITEMS} onClick={item => onMenuItemClicked(item, frota)} />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(VeiculosRetornados))
